---
en:
  page_hits:
    admin:
      filters:
        all_time: All time
        custom: Custom
        matching_referrer_page: Matching Referrer Page
        user_logged_in: User Logged In
        week_ago: 1 week ago
      table:
        action: Action
        controller: Controller
        hit_count: Hit Count
        percentage: Percentage
      tabs:
        page_hits: Page Hits
        users: Users
